import React, { SVGAttributes } from 'react'

export const LinkIcon: React.FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 16H7C4.79086 16 3 14.2091 3 12V12C3 9.79086 4.79086 8 7 8H10" stroke="#188967" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 12H8" stroke="#188967" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 16H17C19.2091 16 21 14.2091 21 12V12C21 9.79086 19.2091 8 17 8H14" stroke="#188967" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
